module.exports = __webpack_public_path__ + "img/Mario.2c9aac67.jpg";